import styled from 'styled-components'
import { settings, shadows } from 'ThemeStyle'

export const BlockWrapper = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: ${settings.blockBorderRadius};
  padding: 1.625rem 1.625rem;
  box-shadow: ${shadows.small};
  transition: all 0.6s ease;
  position: relative;
  box-sizing: border-box;

  &:hover {
    box-shadow: ${shadows.medium};
  }

  @media (max-width: 700px) {
    padding: 1rem;
  }
`
